/* eslint-disable react/jsx-key */
import React, { useState, useEffect, useContext } from 'react'
import { strCol } from '@integec/grid-tools/lib/cols'
import { toSelectionColProps } from '@integec/grid-tools/lib/utils'
import { modifierCol, modifiedDateCol } from 'core/HeaderColTypeProps'
import { getApiTargetInfo } from 'core'
import { connect } from 'react-redux'
import {
  getWindPlantInfo,
  postWindPlantInfo,
  deleteWindPlantInfo,
  getWindUtilityOperatorInfo,
} from 'api/pgads.js'
import { getCompanyNameMap } from 'core/selectors'
import CommonScreen from 'admin/component/CommonScreen'
import { Select, Input, Button } from 'antd'
import R from 'ramda'
import styled from 'styled-components'

import { ErrorContext } from 'context'
import { timeZones, yesNoMap } from 'core/utils'

const TableTD = styled.td`
  text-align: end;
`
const windPlantHeaders = [
  strCol({
    ident: 'plantIdName',
    display: 'Plant Name',
    isKey: true,
    width: 200,
  }),
  strCol({ ident: 'utility', display: 'Utility', isKey: true, width: 400 }),
  strCol({
    ident: 'daylightsavings',
    display: 'Daylightsavings',
    isFiltered: true,
    ...toSelectionColProps(yesNoMap),
    width: 100,
  }),
  strCol({
    ident: 'timeZone',
    display: 'TimeZone',
    isFiltered: true,
    ...toSelectionColProps(timeZones),
    width: 200,
  }),
  modifierCol,
  modifiedDateCol,
]
const retrieveTask = apiTargetInfo => getWindPlantInfo(apiTargetInfo)

const modifyTask = apiTargetInfo => data =>
  postWindPlantInfo(apiTargetInfo)(data)

const deleteTask = apiTargetInfo => data =>
  deleteWindPlantInfo(apiTargetInfo)(data)

const title = 'Wind Plant'

const WindPlant = ({ apiTargetInfo }) => {
  const [insertEvent, setInsertEvent] = useState(false)
  const [utilityNameMap, setUtilityMap] = useState({})
  const { setError } = useContext(ErrorContext)
  useEffect(
    _ =>
      getWindUtilityOperatorInfo(apiTargetInfo).fork(setError, data => {
        const mapData = R.compose(
          R.reduce((a, b) => ({ ...a, ...b }), {}),
          R.map(d => ({ [d.utility]: d.utilityName || d.utility }))
        )(data)
        setUtilityMap(mapData || {})
      }),
    [apiTargetInfo, setError]
  )
  // const reloadUtilityNameMap = data => {
  //   props.saveUtility(data)
  // }

  // const sortOnData = data => {
  //   // const comp = R.comparator((a, b) =>
  //   //   props.companyNameMap[a.companyId] <= props.companyNameMap[b.companyId] ? 1 : -1
  //   // )
  //   const sort = R.sortWith([
  //     R.ascend(R.prop('companyId')),
  //     R.ascend(R.prop('utilityName')),
  //   ])(data)
  //   return sort
  // }

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => {
    return (
      <table
        style={{
          width: '100%',
          borderSpacing: '5px',
          borderCollapse: 'inherit',
        }}
      >
        <tbody>
          <tr>
            <TableTD>Plant Id Name:</TableTD>
            <td style={{ minWidth: '150px' }}>
              <Input
                key="plantIdName"
                value={insertData.plantIdName}
                placeholder="Plant Id Name"
                name="plantIdName"
                onChange={e =>
                  setInsertData({ ...insertData, plantIdName: e.target.value })
                }
              />
            </td>
            <TableTD>Utility:</TableTD>
            <td style={{ minWidth: '150px' }}>
              <Select
                style={{ minWidth: '100%' }}
                placeholder="utility"
                onChange={value =>
                  setInsertData({ ...insertData, utility: value })
                }
                value={insertData.utility}
              >
                {Object.keys(utilityNameMap).map(k => (
                  <Select.Option value={k}>
                    {k}-{utilityNameMap[k]}
                  </Select.Option>
                ))}
              </Select>
            </td>
            <TableTD>Daylight Saving :</TableTD>
            <td style={{ minWidth: '150px' }}>
              <Select
                style={{ minWidth: '100%' }}
                placeholder="daylightsavings"
                onChange={value =>
                  setInsertData({ ...insertData, daylightsavings: value })
                }
              >
                <Select.Option value="Y">Yes</Select.Option>
                <Select.Option value="N">No</Select.Option>
              </Select>
            </td>
            <TableTD>Time Zone:</TableTD>
            <td style={{ minWidth: '150px' }}>
              <Select
                style={{ minWidth: '100%' }}
                placeholder="timeZone"
                onChange={value =>
                  setInsertData({ ...insertData, timeZone: value })
                }
              >
                {Object.keys(timeZones).map(t => (
                  <Select.Option key={t} value={t}>
                    {timeZones[t]}
                  </Select.Option>
                ))}
              </Select>
            </td>
            <td>
              <Button type="primary" onClick={() => onAdd(true)}>
                Add
              </Button>
            </td>
            <td>
              <Button type="primary" onClick={() => onAdd(false)}>
                Add & Hide
              </Button>
            </td>
            <td>
              <Button type="danger" onClick={onCancel}>
                Cancel
              </Button>
            </td>
          </tr>
        </tbody>
      </table>
    )
  }

  const headerWithFormatter = windPlantHeaders.map(header =>
    header.ident === 'utility'
      ? {
          ...header,
          ...toSelectionColProps(utilityNameMap),
          dataFormatter: ({ value }) =>
            utilityNameMap[value]
              ? value + ' - ' + utilityNameMap[value]
              : value,
          sortIndexGetter: ({ rowData }) =>
            utilityNameMap[rowData.utility] || rowData.utility,
        }
      : header.ident === 'daylightsavings'
      ? {
          ...header,
          sortIndexGetter: ({ rowData }) => rowData.daylightsavings,
        }
      : header
  )

  return (
    <CommonScreen
      title={title}
      header={headerWithFormatter}
      saveTask={modifyTask}
      retrieveTask={retrieveTask}
      deleteTask={deleteTask}
      altBy={d => d.utility}
      autoRetrieve
      widthOffset={150}
      insertComp={insertEvent && insertComp}
      insertCompHeight={90}
      onInsertEvent={b => setInsertEvent(b)}
      // onRetrieveData={reloadUtilityNameMap}
      sortEnabled
      // sortOnData={sortOnData}
      // sortOptions={[
      //   strCol({
      //     ident: 'plantIdName',
      //     sortOrder: 'asc',
      //   }),
      //   strCol({
      //     ident: 'utility',
      //     sortOrder: 'asc',
      //   }),
      // ]}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  companyNameMap: getCompanyNameMap(state),
  // utilityNameMap: getUtilityNameMap(state),
})
// eslint-disable-next-line no-unused-vars
const mapDispatchToMap = dispatch => ({
  // saveUtility: utilities =>
  //   dispatch({ type: STORE_UTILITY, payload: utilities }),
})

export default connect(mapStateToProps, mapDispatchToMap)(WindPlant)
